import { DivSkeleton, Flex } from '@fastnorth/kraken/components/layout';
import type { ReactElement } from 'react';

const SummaryStatSkeleton = (): ReactElement => {
  return (
    <Flex className={'flex-col'} gap={'3'}>
      <DivSkeleton grayVariant={300} className="h-7 w-[50px]" />

      <Flex className={'flex-col w-full'} gap={'3'}>
        <DivSkeleton grayVariant={300} className="h-7 w-[100px]" />
        <Flex className={'flex-col text-muted-foreground text-sm'} gap={'3'}>
          <DivSkeleton grayVariant={300} className="h-[20px] w-[150px]" />
          <DivSkeleton grayVariant={300} className="h-[20px] w-[150px]" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SummaryStatSkeleton;
